export default {
  home: "خانه",
  book: "کتاب",
  stock: "موجودی",
  outOfStock: "ناموجود",
  price: "قیمت",
  addToCart: "افزودن به سبد خرید",
  downloadAllVideos: "دانلود کلیپ‌ها و ویدیوها",
  copied: "لینک کپی شد!",
   description: "توضیحات",
  chapters: "سرفصل‌ها",
  reviews: "نظرات",
  noDescription: "توضیحاتی برای این محصول ثبت نشده است.",
  chaptersPlaceholder: "محتوای سرفصل‌ها در این بخش قرار می‌گیرد.",
  reviewsPlaceholder: "بخش نظرات کاربران در این قسمت قرار می‌گیرد.",

  noChapters: "سرفصلی برای این محصول ثبت نشده است.",
noMediaInChapter: "محتوایی در این سرفصل وجود ندارد.",
playAudio: "پخش صوت",
watchClip: "مشاهده فیلم",
playGame: "شروع بازی",
mediaCount: "محتوا",

commentsTitle: "نظرات کاربران",
noComments: "هنوز نظری برای این محصول ثبت نشده است. اولین نفری باشید که نظر می‌دهد!",
submitComment: "ثبت نظر",
yourRating: "امتیاز شما",
yourName: "نام و نام خانوادگی",
yourComment: "متن نظر شما",
namePlaceholder: "نام خود را وارد کنید",
commentPlaceholder: "تجربه خود را درباره این محصول بنویسید...",
commentSuccess: "نظر شما با موفقیت ثبت شد و پس از بررسی نمایش داده می‌شود.",
sendBtn: "ارسال نظر",
userFallback: "کاربر",

  toman: "تومان",
  noProducts: "محصولی یافت نشد.",
  serverError: "خطا در برقراری ارتباط با سرور. لطفاً دوباره تلاش کنید.",
  addToWishlist: "افزودن به علاقه‌مندی‌ها",
  removeFromWishlist: "حذف از علاقه‌مندی‌ها",

  urls: {
    home: "/",
    ProductCategory: "/product-category",
  },
};
